import { inject, Pipe, PipeTransform } from "@angular/core";

import moment from "moment";
import { TranslationService } from "src/app/i18n";

@Pipe({
  name: "customDate",
})
export class CustomDatePipe implements PipeTransform {
  private translationService = inject(TranslationService);

  transform(value: Date | string, format?: string) {
    const lang = this.translationService.getSelectedLanguage();
    moment.locale(lang);
    const result = moment(value);

    if (lang === "th") {
      result.add(543, "year");
    }

    return result.format(format != null && format !== "" ? format : "DD MMMM YYYY");
  }
}
